module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_82-2b4e2e04c6864123a9a1567c9be25d41.png";